<template>
  <div 
    class="ios-add-row" 
    :class="{ 'ios-add-row--last': last }"
    @click="handleClick"
  >
    <v-icon size="20" color="primary" class="add-icon">mdi-plus</v-icon>
    <span class="add-label">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true
  },
  last: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
.ios-add-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  min-height: 44px;
  border-top: 1px solid rgba(var(--v-theme-sheetText), 0.1);
  cursor: pointer;
  transition: background 0.15s ease;
  
  &:active {
    background: rgba(var(--v-theme-sheetText), 0.12);
  }
  
  &--last {
    border-bottom: none;
  }
}

.add-icon {
  margin-right: 12px;
}

.add-label {
  font-size: 1rem;
  color: rgb(var(--v-theme-primary));
}
</style>
